import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }) => {
  return {
    noBorder: {
      border: 'none'
    },
    circle: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      background: '#accaff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      cursor: 'pointer'
    },
    language: css`
      cursor: pointer;
    `,
    icon: css`
      cursor: pointer;
      margin-left: 20px;
      &:hover {
        opacity: 0.85;
      }
    `
  };
});
